<template>
    <x-text-field
        :name="name"
        v-model="num"
        :rules="rules"
        :mask="mask"
        :hint="formattedNumber"
        :persistent-hint=true
        :hide-details="hideDetails"
        :maxlength="maxLength"
        :disabled="disabled"
        ref="currencyTextField"
        v-bind="$attrs"
    />
</template>

<script>
    export default {
        inheritAttrs: false,
        name: 'XCurrencyTextField',
        props: {
            value: {},
            name: {},
            rules: {},
            currency: {},
            inputStyle: {},
            items: {},
            hideDetails: {
                type: Boolean
            },
            hideHelper: Boolean,
            disabled: {},
            mask: {},
            maxLength: {
                default: 18,
                type: Number
            },
            decimals: {
                default: 2,
                type: Number
            },
        },
        computed: {
            formattedNumber() {
                if (this.hideHelper) {
                    return undefined;
                }

                return this.$options.filters.numberToEnglish(this.num);
            },
            num: {
                get () {
                    return this.$options.filters.formatMoney(this.value, this.decimals);
                },
                set (newValue) {
                    if (typeof newValue === "undefined") {
                        newValue = '';
                    }
                    const cleanNumber = newValue === '' ? '' : parseFloat(newValue.toString().replace(/,/g, ''));
                    this.$emit('input', cleanNumber);
                }
            }
        },
        watch: {
            num(newNum = '', oldNum = '') {
                if (oldNum === null || typeof oldNum === "undefined") {
                    return;
                }

                if (newNum === null || typeof newNum === "undefined") {
                    newNum = '';
                }

                // Keep the cursor in the correct position after formatting the number (1000 to 1,000 etc)
                const input = this.$refs.currencyTextField.$refs.input;
                const movement = (newNum.match(/,/g) || []).length - (oldNum.match(/,/g) || []).length;
                const newPos = input.selectionStart + movement;

                this.$nextTick(() => {
                    input.selectionStart = newPos;
                    input.selectionEnd = newPos;
                });
            }
        }
    }
</script>
